import * as Yup from 'yup';

export const forgotPasswordSchema = (localization: any) => {
    return Yup.object().shape({
        email: Yup.string().email(localization.errors.email_invalid).required(localization.errors.email_required)
    });
};
